// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cald_loader_body {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(2, 0, 0, 0.27);
  /*MLM-1536*/
  /*MLM-1536-END*/
  cursor: pointer;
}
.cald_loader_body .cald_spin_container {
  top: 50%;
  left: 50%;
  position: absolute;
  background: none;
  width: 25rem;
  height: 15rem;
  padding-top: 1.5rem;
  padding-left: 7.5rem;
  margin-left: -10rem;
  margin-top: -10rem;
}
.cald_loader_body .cald_spin_container .cald_loader_text {
  padding-top: 1.5rem;
  font-size: 1.6rem;
  text-align: left;
  color: #FFFFFF;
}
.cald_loader_body .cald_spin_container .cancel_request {
  text-decoration: underline;
}

@keyframes faspin_color {
  0% {
    color: #00A8E3;
  }
  25% {
    color: #9E57A2;
  }
  50% {
    color: #FDB823;
  }
  75% {
    color: #98C83C;
  }
  100% {
    color: #00A8E3;
  }
}
span.cald_spinner_color.small i.fa-spin, span.cald_spinner_color.small {
  font-size: 1.25em;
}

span.cald_spinner_color.medium i.fa-pulse, span.cald_spinner_color.medium {
  font-size: 1.775em;
}

span.cald_spinner_color.large i.fa-pulse, span.cald_spinner_color.large {
  font-size: 2.5em;
}

i.cald_spinner_color, span.cald_spinner_color {
  margin-left: 5px;
  animation: faspin_color 7s infinite linear;
}

i.cald_spinner_color.slow, span.cald_spinner_color.slow {
  animation: faspin_color 15s infinite linear;
}

span.icon-radio-unchecked.done {
  font-size: 1.5em;
  color: #98C83C;
  vertical-align: text-bottom;
}

/* Font-awesome overrides */
.fa-spin.slow {
  animation: fa-spin 5s infinite linear;
}

.fa-pulse.slow {
  animation: fa-spin 2s infinite steps(8);
}`, "",{"version":3,"sources":["webpack://./src/app/components/loader/loader.component.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,WAAA;EAEA,eAAA;EACA,eAAA;AADJ;AAEI;EACI,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AACQ;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACZ;AACQ;EACE,0BAAA;AACV;;AAGA;EACI;IACI,cAAA;EAAN;EAEE;IACI,cAAA;EAAN;EAEE;IACI,cAAA;EAAN;EAEE;IACI,cAAA;EAAN;EAEE;IACI,cAAA;EAAN;AACF;AAGA;EACI,iBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,gBAAA;EAEA,0CAAA;AADJ;;AAIA;EAEI,2CAAA;AADJ;;AAIA;EACI,gBAAA;EACA,cAAA;EACA,2BAAA;AADJ;;AAKA,2BAAA;AACA;EAEI,qCAAA;AAFJ;;AAKA;EAEI,uCAAA;AAFJ","sourcesContent":["\n.cald_loader_body{\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(2,0,0,0.27);\n    /*MLM-1536*/\n    // z-index: 1000;\n    /*MLM-1536-END*/\n    cursor: pointer;\n    .cald_spin_container{\n        top: 50%;\n        left: 50%;\n        position: absolute;\n        background: none;\n        width:25rem;\n        height: 15rem;\n        padding-top: 1.5rem;\n        padding-left: 7.5rem;\n        margin-left: -10rem;\n        margin-top:-10rem;\n        .cald_loader_text{\n            padding-top: 1.5rem;\n            font-size: 1.6rem;\n            text-align: left;\n            color:#FFFFFF;\n        }\n        .cancel_request{\n          text-decoration: underline;\n        }\n    }\n}\n@keyframes faspin_color {\n    0% {\n        color: #00A8E3;\n    }\n    25% {\n        color: #9E57A2;\n    }\n    50% {\n        color: #FDB823;\n    }\n    75% {\n        color: #98C83C;\n    }\n    100% {\n        color: #00A8E3;\n    }\n}\n\nspan.cald_spinner_color.small i.fa-spin, span.cald_spinner_color.small {\n    font-size: 1.25em;\n}\n\nspan.cald_spinner_color.medium i.fa-pulse, span.cald_spinner_color.medium {\n    font-size: 1.775em;\n}\n\nspan.cald_spinner_color.large i.fa-pulse, span.cald_spinner_color.large {\n    font-size: 2.5em;\n}\n\ni.cald_spinner_color, span.cald_spinner_color {\n    margin-left: 5px;\n    -webkit-animation: faspin_color 7s infinite linear;\n    animation: faspin_color 7s infinite linear;\n}\n\ni.cald_spinner_color.slow, span.cald_spinner_color.slow {\n    -webkit-animation: faspin_color 15s infinite linear;\n    animation: faspin_color 15s infinite linear;\n}\n\nspan.icon-radio-unchecked.done {\n    font-size: 1.5em;\n    color: #98C83C;\n    vertical-align: text-bottom;\n}\n\n\n/* Font-awesome overrides */\n.fa-spin.slow {\n    -webkit-animation: fa-spin 5s infinite linear;\n    animation: fa-spin 5s infinite linear;\n}\n\n.fa-pulse.slow {\n    -webkit-animation: fa-spin 2s infinite steps(8);\n    animation: fa-spin 2s infinite steps(8);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
